import BaseService from "../CorBase/BaseService";
import BaseFilter from '../CorBase/BaseFilter';

export class TaskService extends BaseService {
	constructor() {
		super('/task');
	}

	public getAllByFilter(filter: TaskFilter) {
		return super.getAllByFilterBase(filter);
	}

	public getRefreshById(id: number) {
		return super.getByIdWithResourceName(id, this._resourceName + '/refresh');
	}

	public getAllByRefreshFilter(filter: TaskFilter) {
		return super.getAllByFilterBase(filter,'refresh');
	}

	public delegateAndActivate(id: number) {
		return this.updateBase(`${this._resourceName}/delegate-activate/${id}`, null);
	}

	public delegate(id: number) {
		return this.updateBase(`${this._resourceName}/delegate/${id}`, null);
	}

	public stopTask(id: number) {
		return this.updateBase(`${this._resourceName}/stop-task/${id}`, null);
	}

	public activateTask(id: number) {
		return this.updateBase(`${this._resourceName}/activate-task/${id}`, null);
	}
	
	//VaPTODO - dodelat
	public createTaskComponent(data: any) {
		return this.createBase(this._resourceName + '/task-component', data);
	}

	public deleteTaskComponent(idTask: number, idComponent: number) {
		return this.deleteBase(`${this._resourceName}/task-component/${idTask}/${idComponent}`);
	}


	public deleteList(list: number[]) {
		return this.deleteListWithResourceName(list, 'delete-list');
	}

	public delegateList(list: number[]) {
		return this.updateListWithResourceName(list, 'delegate-list');
	}

	public stopList(list: number[]) {
		return this.updateListWithResourceName(list, 'stop-list');
	}
}

export class TaskFilter extends BaseFilter {
	constructor(idTenant?: number | null, isDeleted?: boolean | null) {
		super();
		this._idTenant = idTenant;
		this._isDeleted = isDeleted;
	}

	private _idTenant?: number | null;
	private _isDeleted?: boolean | null;

	public getAllParams(): {} {
		let data = Object.assign({},
			(this._idTenant != null ? { IdTenant: this._idTenant } : {}),
			(this._isDeleted != null ? { IsDeleted: this._isDeleted } : {})
		);

		return data;
	};
}